export var MemberKind;
(function (MemberKind) {
    MemberKind["MEMBER"] = "member";
    MemberKind["FUNCTION"] = "function";
})(MemberKind || (MemberKind = {}));
//# sourceMappingURL=manifest.js.map